import { ButtonHTMLAttributes } from 'react'

import s from './Button.module.css'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode
  variant?: 'primary' | 'default' | 'destructive' | 'secondary' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  iconLeft?: React.ReactNode
  iconRight?: React.ReactNode
}
export const Button = ({
  children,
  variant = 'default',
  size = 'md',
  type = 'button',
  disabled = false,
  iconLeft,
  iconRight,
  onClick,
  ...rest
}: Props) => {
  return (
    <button
      className={`${s.button} ${s[variant]} ${s[size]}`}
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {iconLeft && <span className={s.icon}>{iconLeft}</span>}
      {children}
      {iconRight && <span className={s.icon}>{iconRight}</span>}
    </button>
  )
}
